module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "box"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pd-bottom-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', [_c('div', {
    style: ({
      'color': _vm.theme
    }),
    attrs: {
      "id": "title"
    }
  }, [_vm._v("                  \n                " + _vm._s(_vm.title) + "\n              ")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 10px 0px 10px"
    }
  }, [_c('v-select', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filters,
      "label": "Filter",
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "change": _vm.selectedChangeHandler
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mg-top-0"
  }, [_c('v-col', {
    staticClass: "pd-top-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-container', {
    staticClass: "pd-top-0"
  }, [_c('v-row', _vm._l((_vm.previews.avgBlocks), function(item, index) {
    return _c('v-col', {
      key: index
    }, [_c('div', {
      attrs: {
        "id": "avgbox"
      }
    }, [_c('div', {
      attrs: {
        "id": "avg"
      }
    }, [_vm._v(_vm._s(item.avg))]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "avgTitle"
      }
    }, [_vm._v(_vm._s(item.title))])])])
  }), 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', _vm._l((_vm.fields), function(field, index) {
          return _c('th', {
            key: index,
            staticClass: "text-center",
            staticStyle: {
              "border": "none !important"
            }
          }, [_vm._v("\n                                " + _vm._s(field.header) + "\n                            ")])
        }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.previews.items), function(item, index) {
          return _c('tr', {
            key: index
          }, _vm._l((_vm.fields), function(field, index) {
            return _c('td', {
              key: index,
              staticStyle: {
                "line-height": "35px",
                "padding": "0px 0px",
                "font-weight": "300"
              },
              attrs: {
                "align": "center"
              }
            }, [(index === 0) ? _c('div', {
              staticClass: "left-div-border",
              style: ({
                'border-left-color': _vm.theme
              })
            }) : _vm._e(), _vm._v(" "), (field.format[0] === 'multiple') ? _c('div', [_vm._v(_vm._s(item[field.name[0]]) + "/" + _vm._s(item[field.name[1]]) + "\n                                  "), _c('span', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(field.format[1]))])]) : _c('div', [(field.type === 'money') ? _c('div', [_vm._v("\n                                      " + _vm._s(item[field.name]) + "\n                                      "), _c('span', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(field.format[1]))])]) : _c('div', [_vm._v(_vm._s(item[field.name]))])])])
          }), 0)
        }), 0)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mg-top-0"
  }), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "text": "",
      "color": _vm.theme
    },
    on: {
      "click": _vm.seeMoreModalOpen
    }
  }, [_vm._v("See More...")])], 1)], 1)], 1), _vm._v(" "), _c('see-more', {
    key: _vm.seeMoreDialogKey,
    attrs: {
      "dialog": _vm.seeMoreDialog,
      "title": _vm.title,
      "closeDialog": _vm.seeMoreModalClose,
      "headers": _vm.fields,
      "DataItems": _vm.detail.items,
      "theme": _vm.theme,
      "filterItems": _vm.filters,
      "filterCampaigns": _vm.filterCampaigns,
      "avgArray": _vm.detail.avgBlocks,
      "type": _vm.type
    },
    on: {
      "searchFilter": _vm.seeMoreFilter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecae0f50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/CampaignsActivities.vue
// module id = 2310
// module chunks = 0